import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FaBars, FaTimes, FaSignOutAlt, FaBox, FaCogs, FaFileInvoice, FaUndo, FaTruck } from 'react-icons/fa';
import logo from '../../assets/img.jpg';
import './MobileAdminNav.css';

// Mobile navigation for apps portals (Inventory/Billing). It reuses CSS but labels are portal-specific.
const MobileAppsNav = ({ portal }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isInventory = portal === 'inventory';
  const isBilling = portal === 'billing';

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  useEffect(() => { setIsMenuOpen(false); }, [location.pathname]);

  useEffect(() => {
    const handleEscape = (e) => { if (e.key === 'Escape' && isMenuOpen) closeMenu(); };
    if (isMenuOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  // Define portal-specific menu items
  const inventoryItems = [
    { path: '/apps.avsbusiness.com/inventory', icon: FaBox, label: 'Inventory' },
    { path: '/apps.avsbusiness.com/inventory/vendors', icon: FaTruck, label: 'Vendors' },
    { path: '/apps.avsbusiness.com/inventory/manufacturing-categories', icon: FaCogs, label: 'Manufacturing Categories' },
  ];
  const billingItems = [
		{ path: '/apps.avsbusiness.com', icon: FaFileInvoice, label: 'Billing Dashboard' },
		{ path: '/apps.avsbusiness.com/billing', icon: FaFileInvoice, label: 'Billing' },
    { path: '/apps.avsbusiness.com/accounts-ledger', icon: FaFileInvoice, label: 'Accounts Ledger' },
    { path: '/apps.avsbusiness.com/client-ledger', icon: FaFileInvoice, label: 'Client Ledger' },
    { path: '/apps.avsbusiness.com/returns', icon: FaUndo, label: 'Return Product' },
  ];
  const menuItems = isInventory ? inventoryItems : billingItems;

  return (
    <>
      <header className="mobile-admin-header">
        <div className="mobile-header-content">
          <div className="mobile-logo">
            <img src={logo} alt="AVS Business Logo" className="mobile-menu-logo" />
          </div>
          <button className="mobile-menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </header>

      {isMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMenu}>
          <div className="mobile-menu" onClick={e => e.stopPropagation()}>
            <div className="mobile-menu-header">
              <img src={logo} alt="AVS Business Logo" className="mobile-menu-logo" />
              <h3>{isInventory ? 'Inventory Menu' : 'Billing Menu'}</h3>
              <button className="mobile-menu-close" onClick={closeMenu} aria-label="Close menu">
                <FaTimes />
              </button>
            </div>

            <nav className="mobile-menu-nav">
              <ul className="mobile-menu-list">
                {menuItems.map((item) => {
                  const IconComponent = item.icon;
                  return (
                    <li key={item.path} className="mobile-menu-item">
                      <Link 
                        to={item.path}
                        className={`mobile-menu-link ${location.pathname === item.path ? 'active' : ''}`}
                        onClick={closeMenu}
                      >
                        <IconComponent className="mobile-menu-icon" />
                        <span className="mobile-menu-text">{item.label}</span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </nav>

            <div className="mobile-menu-footer">
              <button onClick={handleLogout} className="mobile-logout-button">
                <FaSignOutAlt className="mobile-logout-icon" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileAppsNav;


